<template>
  <v-dialog :value="value" width="1200px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        <span class="table-card-title">Lista de números</span>
        <v-spacer />
        <export-whatsapp-contacts-dialog />
        <mf-tabs-button v-model="typeToggle" class="ml-2" size="sm" :buttons="toggleButtons" />
      </v-card-title>
      <v-card-text>
        <div style="max-height: 500px; overflow-y: auto">
          <paginated-data-table :headers="headers" :query="query" :query-variables="queryVariables" queryName="getContacts" queryMainPropertyName="contacts">
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ phoneNumberFormat(item.number) }}</td>
                <td>
                  {{ item.sender ? `${phoneNumberFormat(item.sender.number)} - ${item.sender.name}` : `${phoneNumberFormat(item.register)} - Desconectado` }}
                </td>
                <td>
                  <router-link v-if="item.client_id" class="link" :to="{ path: `/clientes/detalhes-cliente/${item.client_id}` }">
                    <span>{{ item.client_id }}</span>
                  </router-link>
                  <span v-else>{{ item.client_id || '-' }}</span>
                </td>
                <td>{{ DateTime.fromISO(item.created_at).toFormat('dd/MM/yyyy') }}</td>
                <td>{{ DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy') }}</td>
              </tr>
            </template>
          </paginated-data-table>
        </div>
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Fechar',
            action: close,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PaginatedDataTable from '@/components/PaginatedDataTable'
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { DateTime } from 'luxon'
import { QUERY_GET_CONTACTS } from '@/modules/campanhas/whatsapp/graphql'

export default {
  components: {
    PaginatedDataTable,
    ExportWhatsappContactsDialog: () => import('@/modules/campanhas/whatsapp/views/components/ExportWhatsappContactsDialog.vue'),
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    typeToggle: true,
    phoneNumberFormat: phoneNumberFormat,
    DateTime: DateTime,
  }),
  computed: {
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Inscritos',
          value: true,
          active: true,
        },
        {
          id: 1,
          label: 'Desistentes',
          value: false,
          active: true,
        },
      ]
    },
    headers() {
      return [
        {
          text: 'Número',
          value: 'number',
          sortable: true,
          width: '15%',
          sort: (a, b) => (String(a) > String(b) ? 1 : -1),
        },
        {
          text: 'Disparador',
          value: 'sender',
          sortable: false,
          width: '30%',
        },
        {
          text: 'ID Cliente',
          value: 'client_id',
          sortable: true,
          width: '20%',
        },
        {
          text: 'Data de cadastro',
          value: 'created_at',
          sortable: true,
          width: '15%',
        },
        {
          text: 'Data de atualização',
          value: 'updated_at',
          sortable: true,
          width: '25%',
        },
      ]
    },
    query() {
      return QUERY_GET_CONTACTS
    },
    queryVariables() {
      return {
        active: this.typeToggle,
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style></style>
